      export const DecentralizedKYCSystem = "0x2882ACcc6617F108C63776aF29323166E122E09A" 
      export const ColletionsERC721 = "0xa28793F250C5c111d06C5384DD3A03eD691Dea5F"
      export const MarketplaceERC721 = "0x7F46ee984dCb80BD2397B8FA16E8f6dc6D58F990" 
      export const ColletionsERC1155 = "0x36BB6334BB7b1C7b9906698b44155D797d03dA54"
      export const MarketplaceERC1155 = "0xbCDFd1b69FECb832355709b6Bc8a4EC2be51320d" 
      export const VipcardERC721 = "0xd2C99D038471A9268D0B52f8B294372b59aAfD96"
      export const CommunityAuth = "0xF24085f94f6a4986D8C47470f47E34992D8EcA7f"
      export const CommunityToken = "0x67De2356503520fdE9Ae7891dF5EF250CAD9bBa2"
      export const ownerAddress = "0x918265e9e48ffB46493deef03Cc2CFbC7c50425f"
      export const networkDeployedTo = "137"